// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"8a0ed6c2","453":"98bb2bcc","678":"fa0ee4f7"}[chunkId] + ".chunk.js";
};